export default __webpack_public_path__ + "static/freelancer-fcb38f8fd206a6910a70a1c12635ef0e.svg";